import styled from '@emotion/styled';
import { Component } from 'react';

const Counter = styled.div`
  display: inline-block;
  font-size: 0.857em;
  font-weight: 300;
  margin-bottom: 0.5em;
  position: relative;
  text-align: center;
  width: 100%;
`;

export default class WidgetCounter extends Component {
  render() {
    const { current, total, of = 'of' } = this.props;

    return <Counter>{`${current} ${of} ${total}`}</Counter>;
  }
}
